import { CheckboxMultiple } from 'mixs/inputs/checkbox-multiple';
export class ComplexCheckboxCheckReports extends CheckboxMultiple {
  public init(): void {
    super.init();
    this.listenMount([this.onMountTag])
  }
  public onMountTag(){
    const json = this.reportsNumbersJSON()
    this.dispatch({reports_numbers: {value: json}, updated_at: new Date().getTime()});
  }
  public onChangeCheckbox(e){
    //    this.onChange(e);
    const isChecked = e.target.checked
    const value = isChecked ? '1' : '0';
    const checked = isChecked ? 'checked' : '';
    let namespace = e.target.getAttribute('data-id');
    let items = {};
    items[namespace] = { value: value, checked: checked }
    const item = this.opts.items[namespace]
    if(isChecked && item.number && item.number.value == '0'){
      items[namespace]['number'] = { value: '1' }
    }else if(!isChecked && item.number && item.number.value != '0'){
      items[namespace]['number'] = { value: '0' }
    }
    this.dispatch({items: items, updated_at: new Date().getTime()});
  }
  public onChangeNumber(e){
    const value = e.target.value
    const namespace = e.target.getAttribute('data-id')
    const item = this.opts.items[namespace]
    const number = parseInt(value)
    let items = {}
    items[namespace] = { number: { value: value } }
    if(number <= 0 && item.value == '1'){
      items[namespace]['value'] = '0'
      items[namespace]['checked'] = ''
    }else if(number > 0 && item.value == '0'){
      items[namespace]['value'] = '1'
      items[namespace]['checked'] = 'checked'
    }
    const json = this.reportsNumbersJSON()
    this.dispatch({items: items, reports_numbers: {value: json}, updated_at: new Date().getTime()});
  }
  public reportsNumbersJSON(){
    let ary = []
    const numberInputs = this.querySelectorAll('.number-group input[type="number"]')
    for(let i = 0; i < numberInputs.length; i++){
      const input = numberInputs[i] as HTMLInputElement
      const namespace = input.getAttribute('data-id')
      const value = input.value
      ary.push(`"${namespace}": "${value}"`)
    }
    return `{${ary.join(',')}}`
  }
}

riot.mixin('inputs.complex.checkbox-check-reports', ComplexCheckboxCheckReports as riot.TagMixin)
